module.exports = __webpack_public_path__ + "img/Zwono_Logo-H-White-RGB-190x50.61398e0b.svg";